import { render, staticRenderFns } from "./RegrasDeAgrupamento.vue?vue&type=template&id=c4bfb236&scoped=true"
import script from "./RegrasDeAgrupamento.vue?vue&type=script&lang=js"
export * from "./RegrasDeAgrupamento.vue?vue&type=script&lang=js"
import style0 from "./RegrasDeAgrupamento.vue?vue&type=style&index=0&id=c4bfb236&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4bfb236",
  null
  
)

export default component.exports